module.exports = __webpack_public_path__ + "static/dragonfly-f1c463f9d27e02058fc20484d94c2302.svg";